import { render, staticRenderFns } from "./FrequentQuestionsBanner.vue?vue&type=template&id=1f1817ee"
import script from "./FrequentQuestionsBanner.vue?vue&type=script&lang=js"
export * from "./FrequentQuestionsBanner.vue?vue&type=script&lang=js"
import style0 from "./FrequentQuestionsBanner.vue?vue&type=style&index=0&id=1f1817ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports